import { DateTime } from 'luxon'
import type { CalendarDay } from '~/interfaces/CalendarDay'

const WEEKS_SHOWN = 6
const DAYS_PER_WEEK = 7

/** The 42 days (Monday-first weeks) covering the month that contains `visibleDate` in `timezone`. */
export const buildMonthCalendarDays = (
  visibleDate: Date,
  timezone: string,
  isSelected: (date: string) => boolean
): CalendarDay[] => {
  const visibleMonth = DateTime.fromJSDate(visibleDate).setZone(timezone).startOf('month')
  const startDate = visibleMonth.minus({ days: visibleMonth.weekday - 1 })
  const today = DateTime.now().setZone(timezone).startOf('day')

  return Array.from({ length: WEEKS_SHOWN * DAYS_PER_WEEK }, (_, index) => {
    const date = startDate.plus({ days: index })
    const dateString = date.toFormat('yyyy-MM-dd')

    return {
      date: dateString,
      isCurrentMonth: date.month === visibleMonth.month,
      isPast: date < today,
      isSelected: isSelected(dateString),
      isToday: date.hasSame(today, 'day')
    }
  })
}
